import { rem } from "./utils";
export var maxWidth = {
    md: rem(1040),
    sm: rem(992)
};

//# sourceMappingURL=maxWidth.js.map